import { createApp } from "vue";
import InstantSearch from "vue-instantsearch/vue3/es";

import App from "./App.vue";
import Splide from "@splidejs/splide";
import svg4everybody from "svg4everybody";

// Assets
import "./assets/styles/app.postcss";
import "@/lib/svgSprite";

// Bootstrap
import setLoaded from "@/lib/setLoaded";
import { bindToggles } from "@/lib/toggle";

function preflight(APP) {
  svg4everybody();
  bindToggles();
  setLoaded(APP);
}

function initSliders(selector, opts) {
  [...document.querySelectorAll(selector)].forEach((el) => {
    new Splide(el, opts).mount();
  });
}

function init(APP = {}) {
  preflight(APP);

  const CONFIG = { ...APP };

  const DEBUG =
    typeof APP.DEBUG !== "undefined" ? APP.DEBUG : !process.env.NODE_ENV === "production";

  const $search = createApp(App);

  $search.use(InstantSearch);

  $search.config.globalProperties.$ENV = CONFIG;

  initSliders(".splide", {
    autoWidth: true,
    drag: true,
    pagination: false,
    perMove: 3,
    padding: { left: "calc((( 100vw - var(--container-width)) * 0.5) - 1.5rem )" },
  });

  return {
    CONFIG,
    DEBUG,
    $search,
    $vm: $search.mount("#search"),
  };
}

window.addEventListener("DOMContentLoaded", () => {
  window.APP = init(window.APP);
});
